import Svg from "./figs/Svg";

export default function GroupCard({
  msg,
  numOfAdult = 0,
  numOfChild = 0,
  numOfInfant = 0,
  groupId,
  onCheck,
  onView,
  disabledCheckbox = false,
  agent,
}) {
  const num_of_passenger = +numOfAdult + +numOfChild + +numOfInfant;
  return (
    <div className="group_card">
      <div className="icon" onClick={onView}>
        <Svg iconName="boat" />
      </div>
      <div className="detail" onClick={onView}>
        <h2>{`${msg.group_id}: ${groupId}`}</h2>
        {agent && (
          <div className="agent">
            <span>{`${msg.agent} : `}</span>
            <span>{agent}</span>
          </div>
        )}
        <div className="passenger">
          <span>{`${msg.passenger} : `}</span>
          <span>{`${num_of_passenger} ${msg.pax}`}</span>
        </div>
        <div className="num_of_passenger_list">
          <span>
            <span>{`${msg["adult(s)"]} : `}</span>
            <span>{numOfAdult}</span>
          </span>
          <span>
            <span>{`${msg["child(s)"]} : `}</span>
            <span>{numOfChild}</span>
          </span>
          <span>
            <span>{`${msg["infant(s)"]} : `}</span>
            <span>{numOfInfant}</span>
          </span>
        </div>
      </div>
      <input disabled={disabledCheckbox} onClick={onCheck} type="checkbox" />
    </div>
  );
}
